module.exports = __webpack_public_path__ + "static/media/footer_logo_nomura-am.e3543f50.jpg";